import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=641d23b8&scoped=true&lang=pug&"
import script from "./Main.vue?vue&type=script&lang=ts&"
export * from "./Main.vue?vue&type=script&lang=ts&"
import style0 from "./Main.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./Main.vue?vue&type=style&index=1&id=641d23b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d23b8",
  null
  
)

export default component.exports